import {MD_WIDTH, LG_WIDTH} from "@main/helpers/const";
import Swiper, {Navigation} from "swiper";

export class SwiperSlider {
    constructor(el) {
        this.el = el;
        this.swiperNode = this.el.querySelector(".js-swiper-container");
        this.prevButton = this.el.querySelector(".js-swiper-prev");
        this.nextButton = this.el.querySelector(".js-swiper-next");
        this.options = {
            modules: [Navigation],
            slidesPerView: Number(this.swiperNode.dataset.slidePerView) || "auto",
            clickable: true,
            slideToClickedSlide: true,
            spaceBetween: Number(this.swiperNode.dataset.slideSpace) || 8,
            breakpoints: {
                [MD_WIDTH]: {
                    slidesPerView: Number(this.swiperNode.dataset.mdSlidePerView) || "auto",
                    spaceBetween: Number(this.swiperNode.dataset.mdSlideSpace) || 16,
                },
                [LG_WIDTH]: {
                    slidesPerView: Number(this.swiperNode.dataset.lgSlidePerView) || "auto",
                    spaceBetween: Number(this.swiperNode.dataset.lgSlideSpace) || 16,
                },
            },
            navigation: {
                nextEl: this.nextButton,
                prevEl: this.prevButton,
            },
        };

        this.createSlider();
    }

    createSlider = () => {
        this.swiper = new Swiper(this.swiperNode, this.options);
    };
}

document.querySelectorAll(".js-swiper").forEach((el) => new SwiperSlider(el));
